
export interface IStandAloneAddress {
  addressee: string;
  block: string;
  building: string;
  city: string;
  company: string;
  country: IStandAloneCountry;
  street: string;
  streetNo: string;
  userFields: {[key: string] :Object};
  zipcode: string;
}

export interface IStandAloneBatch {
  code: string;
  expirationDate: any;
  id: number;
  item: IStandAloneItem;
  manufacturedDate: any;
  manufacturerBatchCode: string;
  userFields: {[key: string] :Object};
}

export interface IStandAloneBinLocation {
  active: boolean;
  barcode: string;
  code: string;
  confirmMovementIfNotEmpty: boolean;
  countingSortingCode: string;
  id: number;
  locationType: StandAloneLocationType;
  maximalStockLevel: number;
  minimalStockLevel: number;
  movedStockToKardex: string;
  physicalLocationType: StandAlonePhysicalLocationType;
  pickingStrategy: StandAlonePickingStrategy;
  preferredOrderCode: string;
  readyForProcessing: boolean;
  requiresCounting: StandAloneRequiresCounting;
  sortingCode: string;
  stockMovementRestricted: boolean;
  userFields: {[key: string] :Object};
  warehouse: IStandAloneWarehouse;
}

export interface IStandAloneCountry {
  EU: undefined | boolean;
  addressFormat: string;
  isEU: boolean;
  iso2: string;
  name: string;
}

export interface IStandAloneItem {
  barcode1: string;
  barcode1qty: number;
  barcode2: string;
  barcode2qty: number;
  barcode3: string;
  barcode3qty: number;
  blockForQcType: StandAloneBlockForQcType;
  code: string;
  id: number;
  isStockItem: boolean;
  itemGroup: IStandAloneItemGroup;
  managedBy: StandAloneManagedBy;
  name: string;
  pdfPath: string;
  picture: IStandAloneItemPicture;
  picturePath: string;
  productionIssueMethod: StandAloneProductionIssueMethod;
  productionMaterialToleranceType: StandAloneToleranceType;
  productionMaterialToleranceValue: number;
  qcInstructionFilePath: string;
  scanExpirationDateOnReceipt: boolean;
  scanManufacturingBatchOnReceipt: boolean;
  scanManufacturingDateOnReceipt: boolean;
  scanManufacturingSerialOnReceipt: boolean;
  serialIsManagedByDispatch: boolean;
  stockItem: boolean;
  units: string;
  userFields: {[key: string] :Object};
}

export interface IStandAloneItemGroup {
  id: number;
  name: string;
}

export interface IStandAloneItemPicture {
  id: number;
  picture: string;
}

export interface IStandAlonePurchaseOrder {
  code: string;
  id: number;
  lines: IStandAlonePurchaseOrderLine[];
  orderDate: any;
  reference: string;
  status: any;
  userFields: {[key: string] :Object};
  version: number;
}

export interface IStandAlonePurchaseOrderLine {
  id: number;
  item: IStandAloneItem;
  lineNum: number;
  orderedQuantity: number;
readonly   purchaseOrder: IStandAlonePurchaseOrder;
  userFields: {[key: string] :Object};
}

export interface IStandAlonePurchaseReceipt {
  id: number;
  lines: IStandAlonePurchaseReceiptLine[];
  receiptDate: any;
  status: any;
  userFields: {[key: string] :Object};
}

export interface IStandAlonePurchaseReceiptLine {
  batch: IStandAloneBatch;
  id: number;
  item: IStandAloneItem;
  lineNum: number;
  purchaseOrderLine: IStandAlonePurchaseOrderLine;
readonly   purchaseReceipt: IStandAlonePurchaseReceipt;
  receivedQuantity: number;
  serial: IStandAloneSerial;
  userFields: {[key: string] :Object};
}

export interface IStandAloneSalesDelivery {
  address: IStandAloneAddress;
  containers: IStandAloneSalesDeliveryContainer[];
  deliveryDate: any;
  id: number;
  lines: IStandAloneSalesDeliveryLine[];
  userFields: {[key: string] :Object};
}

export interface IStandAloneSalesDeliveryContainer {
  depth: number;
  height: number;
  id: number;
  labelPath: string;
  lines: IStandAloneSalesDeliveryContainerContent[];
  mediaType: string;
  packingItem: string;
  packingName: string;
  packingType: string;
  salesDelivery: IStandAloneSalesDelivery;
  series: number;
  shippingCode: string;
  shippingMethod: string;
  trackTraceUrl: string;
  userFields: {[key: string] :Object} | {[key: string] :any};
  weight: number;
  width: number;
}

export interface IStandAloneSalesDeliveryContainerContent {
  batch: IStandAloneBatch;
  container: IStandAloneSalesDeliveryContainer;
  id: number;
  item: IStandAloneItem;
  quantity: number;
  serial: IStandAloneSerial;
  userFields: {[key: string] :Object} | {[key: string] :any};
}

export interface IStandAloneSalesDeliveryLine {
  batch: IStandAloneBatch;
  deliveredQuantity: number;
  id: number;
  item: IStandAloneItem;
  lineNum: number;
  location: IStandAloneBinLocation;
readonly   salesDelivery: IStandAloneSalesDelivery;
  salesOrderLine: IStandAloneSalesOrderLine;
  serial: IStandAloneSerial;
  userFields: {[key: string] :Object};
}

export interface IStandAloneSalesOrder {
  address: IStandAloneAddress;
  code: string;
  id: number;
  lines: IStandAloneSalesOrderLine[];
  orderDate: any;
  reference: string;
  status: any;
  userFields: {[key: string] :Object};
}

export interface IStandAloneSalesOrderLine {
  id: number;
  item: IStandAloneItem;
  lineNum: number;
  orderedQuantity: number;
  salesOrder: IStandAloneSalesOrder;
  userFields: {[key: string] :Object} | {[key: string] :any};
}

export interface IStandAloneSerial {
  code: string;
  expirationDate: any;
  id: number;
  item: IStandAloneItem;
  lot: string;
  manufacturedDate: any;
  manufacturerLot: string;
  manufacturerSerial: string;
  userFields: {[key: string] :Object};
}

export interface IStandAloneWarehouse {
  code: string;
  id: number;
  name: string;
  userFields: {[key: string] :Object};
}

export type StandAloneBlockForQcType = 'NONE' | 'BATCH' | 'SERIAL';
export const StandAloneBlockForQcTypeValues: StandAloneBlockForQcType[] = ['NONE' , 'BATCH' , 'SERIAL'];

export type StandAloneLocationType = 'BULK' | 'PICK' | 'MOBILE' | 'RECEIVE' | 'QC' | 'DELIVERY' | 'PRODUCTION' | 'UNKNOWN';
export const StandAloneLocationTypeValues: StandAloneLocationType[] = ['BULK' , 'PICK' , 'MOBILE' , 'RECEIVE' , 'QC' , 'DELIVERY' , 'PRODUCTION' , 'UNKNOWN'];

export type StandAloneManagedBy = 'NORMAL' | 'BATCH_NUMBER' | 'SERIAL_NUMBER';
export const StandAloneManagedByValues: StandAloneManagedBy[] = ['NORMAL' , 'BATCH_NUMBER' , 'SERIAL_NUMBER'];

export type StandAlonePhysicalLocationType = 'NORMAL' | 'KARDEX' | 'DIV' | 'LIQUID_CONTAINER' | 'SINGLE_ITEM_LOCATION';
export const StandAlonePhysicalLocationTypeValues: StandAlonePhysicalLocationType[] = ['NORMAL' , 'KARDEX' , 'DIV' , 'LIQUID_CONTAINER' , 'SINGLE_ITEM_LOCATION'];

export type StandAlonePickingStrategy = 'NORMAL' | 'CONFIRM' | 'SKIP' | 'FOCUS';
export const StandAlonePickingStrategyValues: StandAlonePickingStrategy[] = ['NORMAL' , 'CONFIRM' , 'SKIP' , 'FOCUS'];

export type StandAloneProductionIssueMethod = 'BACKFLUSH' | 'MANUAL';
export const StandAloneProductionIssueMethodValues: StandAloneProductionIssueMethod[] = ['BACKFLUSH' , 'MANUAL'];

export type StandAloneRequiresCounting = 'NO' | 'PARTIAL' | 'YES';
export const StandAloneRequiresCountingValues: StandAloneRequiresCounting[] = ['NO' , 'PARTIAL' , 'YES'];

export type StandAloneToleranceType = 'NONE' | 'PERCENTAGE' | 'QUANTITY';
export const StandAloneToleranceTypeValues: StandAloneToleranceType[] = ['NONE' , 'PERCENTAGE' , 'QUANTITY'];

